(function () {
  'use strict';

  /* @ngdoc object
   * @name flightWatch
   * @description
   *
   */
  angular
    .module('flightWatch', [
      'ui.router'
    ]);
}());
